import React from "react";

interface CustomRadioProps {
  id: string;
  name: string;
  className?: string;
  checked: boolean;
  value?: boolean;
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomRadio: React.FC<CustomRadioProps> = ({
  id,
  name,
  className,
  checked,
  value,
  label,
  onChange,
}) => {
  return (
    <div className="form-check">
      <input
        id={id}
        name={name}
        type="radio"
        className={`form-check-input ${className || ""}`}
        checked={checked}
        value={String(value)}
        onChange={onChange}
      />
      <label htmlFor={id} className={`form-check-label ${className || ""}`}>
        {label}
      </label>
    </div>
  );
};

export default CustomRadio;